import React from 'react';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';
import ProgressBar from 'components/UI/ProgressBar/ProgressBar';

import styles from './ProductsViewed.module.scss';

type PropsType = {
  count: number;
  total: number;
  className?: string;
};

export default function ProductsViewed({
  count,
  total,
  className,
}: PropsType): JSX.Element {
  const progressPercentage = Math.round((count / total) * 100);

  return (
    <div className={classNames(styles.container, className)}>
      <Trans
        i18nKey={'PROGRESSION_PRODUCTS_VIEWED'}
        namespace={'listingPage'}
        values={{ count: count.toString(), total: total.toString() }}
      />
      <ProgressBar
        progress={progressPercentage}
        classes={{ root: styles.progressBarRoot }}
      />
    </div>
  );
}
